import { connect } from "react-redux"

import {
    feedKnowledgeListInvalidationRequest,
    feedSetKnowledgeFilter
} from "../../../actions/feed-actions"

import KnowledgeListWidget from "../../common/knowledge-list/KnowledgeListWidget"
import FeedKnowledgeListContainer from "./FeedKnowledgeListContainer"

const mapStateToProps = state => ({
    knowledgeListContainerComponent: FeedKnowledgeListContainer,
    isFetching:
        state.presentation.feed.isFetchingList ||
        state.presentation.feed.isFetchingItem,
    pagingRequest:
        state.paging.moderationFeed[state.presentation.feed.searchCriteria] ||
        {},
    isFilterEnabled: true,
    isAddingEnabled: true
})

const mapDispatchToProps = dispatch => ({
    invalidate: pagingRequest => () =>
        dispatch(feedKnowledgeListInvalidationRequest(pagingRequest)),
    onFilterSelect: () => dispatch(feedSetKnowledgeFilter(true))
})

export default connect(mapStateToProps, mapDispatchToProps)(KnowledgeListWidget)
